import { Editor, Transforms } from '../../../core';
import { createLineBreak } from '../../lineBreak/utils';

export const insertInlineTemplateLineBreak = (editor: Editor) => {
  const marks = Editor.marks(editor);
  Transforms.insertNodes(editor, [createLineBreak(), { text: '' }]);

  if (marks != null) {
    Object.entries(marks).forEach(([key, value]) => {
      Editor.addMark(editor, key, value);
    });
  }
};
